export default __webpack_public_path__ + "static/media/k13.5a2d9d1f.jpg";